//@ts-nocheck

import React, {useRef} from "react";
import { motion } from 'framer-motion';
import Layout from '../../components/Layout/Layout'

import ActionBtn from '../../components/Button/ActionBtn';

import { Col, Container, Row } from 'react-bootstrap'

import VerticalAccordion from "../../components/Legal/VerticalAccordian";
import AccordionSolutions from "../../components/Legal/AccordianSolutions";
import ContactPage from "../../components/ContactForm/Contact";

import emailjs from '@emailjs/browser';

const sampleDocuments = [
  { text: "Equifax Paynet Sample", pdfUrl: "/SeeSamples/EquifaxPaynetExample.pdf", fileName: "sample_Equifax_Paynet_report.pdf" },
  { text: "Equifax One Score Sample", pdfUrl: "/SeeSamples/EquifaxOne.pdf", fileName: "sample_Equifax_OneScore_Credit_report.pdf" },
  { text: "Experian Sample", pdfUrl: "/SeeSamples/Experian.pdf", fileName: "sample_Experian_Report.pdf" },

];

const samplePersonalDocuments = [
 
  { text: "Personal Equifax Sample", pdfUrl: "/SeeSamples/PersonalSamples/Report-1.pdf", fileName: "sample_Personal_Equifax_Report.pdf" },
  { text: "Personal Experian Sample", pdfUrl: "/SeeSamples/PersonalSamples/Report-2.pdf", fileName: "sample_Personal_Experian_Report.pdf" },
];

const SeeSample = () => {
  const handlePdfDownload = (pdfUrl: string, fileName: string) => {
    fetch(pdfUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      });
  };

  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_t80qe2q',   // Replace with your Service ID
        'template_tn7w75g', // Replace with your Template ID
        formRef.current,    // Reference to the form
        '37maWWNmcPSwXXr8W'  // Replace with your Public Key
      )
      .then(
        (result) => {
          console.log('SUCCESS!', result.text);
          alert('Your message has been sent successfully to our legal team. We will get back to you shortly.');
          e.target.reset();
        },
        (error) => {
          console.log('FAILED...', error.text);
          alert('Oops! Something went wrong. Please try again later.');
        }
      );
  };

  return (
    <Layout title="Legal" description="Legal Documents Page">
     <section className="pt-16 md:pt-24 lg:pt-32 pb-0 relative overflow-hidden">
        <img
          src="/images/Container.svg"
          className="absolute w-full h-full object-cover left-1/2 -translate-x-1/2 top-0 pointer-events-none"
          alt=""
        />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-[1]">
          <motion.h2 
            className="font-bold text-4xl sm:text-5xl md:text-6xl lg:text-6xl mb-4 sm:mb-6 text-black leading-tight"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Samples
          </motion.h2>
          <motion.h2 
            className="font-medium text-3xl sm:text-4xl md:text-5xl lg:text-5xl mb-4 sm:mb-6 text-black leading-tight"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
           Credit Report Samples
          </motion.h2>
          <motion.p 
            className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed mb-8 sm:mb-12"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Check out sample business credit reports and personal credit reports to see what you can expect when you order a credit report.
          </motion.p>
        </div>
      </section>
      <section className="py-12 sm:py-16 bg-gray-50">
        <Container className="px-4 sm:px-6 lg:px-8">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-[1]">
        
          <motion.h2 
            className="font-medium text-3xl sm:text-4xl md:text-5xl lg:text-5xl mb-4 sm:mb-6 text-black leading-tight"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
           Business Credit Report Samples
          </motion.h2>
          <motion.p 
            className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed mb-8 sm:mb-12"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Check out sample business credit reports.
          </motion.p>
        </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {sampleDocuments.map((doc, index) => (
              <motion.div
                key={doc.fileName}
                className="bg-white rounded-2xl sm:rounded-3xl shadow-md sm:shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <div className="p-4 sm:p-6">
                  <h3 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-gray-800">{doc.text}</h3>
                  <ActionBtn
                    title="Download"
                    type={2}
                    isDownload={true}
                    pdfUrl={doc.pdfUrl}
                    fileName={doc.fileName}
                    onClick={() => handlePdfDownload(doc.pdfUrl, doc.fileName)}
                  />
                </div>
              </motion.div>
            ))}
          </div>
        </Container>
      </section>
      <section className="py-12 sm:py-16 bg-gray-50">
        <Container className="px-4 sm:px-6 lg:px-8">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-[1]">
        
          <motion.h2 
            className="font-medium text-3xl sm:text-4xl md:text-5xl lg:text-5xl mb-4 sm:mb-6 text-black leading-tight"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
           Personal Credit Report Samples
          </motion.h2>
          <motion.p 
            className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed mb-8 sm:mb-12"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Check out sample personal credit reports.
          </motion.p>
        </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {samplePersonalDocuments.map((doc, index) => (
              <motion.div
                key={doc.fileName}
                className="bg-white rounded-2xl sm:rounded-3xl shadow-md sm:shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <div className="p-4 sm:p-6">
                  <h3 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-gray-800">{doc.text}</h3>
                  <ActionBtn
                    title="Download"
                    type={2}
                    isDownload={true}
                    pdfUrl={doc.pdfUrl}
                    fileName={doc.fileName}
                    onClick={() => handlePdfDownload(doc.pdfUrl, doc.fileName)}
                  />
                </div>
              </motion.div>
            ))}
          </div>
        </Container>
      </section>
    </Layout>
  );
};

export default SeeSample;

